export const ARTICLE_LIMITS = {
  title: 500,
  slug: 500,
  author: 255,
};

export function generateSlugFromTitle(title, maxLength = ARTICLE_LIMITS.slug) {
  const slug = String(title || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  if (!slug) return "article";
  if (slug.length <= maxLength) return slug;

  return slug.slice(0, maxLength).replace(/-+$/g, "") || "article";
}

export function isValidImageUrl(value) {
  const trimmed = String(value || "").trim();
  if (!trimmed) return false;
  try {
    const url = new URL(trimmed);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}
